<seb-titlebar [hideButtonTitlebar]="hideButtonTitlebar" [paths]='titleHeader' [labelButton]='labelTitleModal'>
  <ng-select [items]="schoolOptions" [(ngModel)]="selectedSchoolOption" (change)="onChangeSelectSchoolOptions($event)"
    bindLabel="fantasyName" [searchable]="false" [clearable]="false" select-custom [ngStyle]="{'width': '250px'}">
  </ng-select>
</seb-titlebar>

<div class="dashboard__row">

  <div class="dashboard__column">
    <seb-reports-box [title]="'Usuários Cadastrados por Perfil'" [value]="dashboardTotalRegistredUsers.total"
      [tooltipText]="'São contabilizados somente usuários adicionados em turmas.'" [reportsBoxHeight]="'429px'"
      [loading]="totalRegistredUsersLoading" [description]="'Total'">
      <seb-progress-bar *ngFor="let profile of dashboardTotalRegistredUsers.profiles" [label]="profile.profile"
        [percentage]="profile.percentage" [value]="profile.total" [backgroundColor]="profile.color">
      </seb-progress-bar>
    </seb-reports-box>

    <seb-reports-box [title]="'Usuários Cadastrados por Produto'" [isSelectVisible]="true" [selectItems]="seriesUserPerApps"
      [selectBindLabel]="'segmentName'" [selectedItem]="selectedSerieRegistredUsersPerApp"
      (selectChange)="onChangeSelectSeriesInUsersPerApp($event)"
      [tooltipText]="'São contabilizados somente usuários com perfil vinculado por aplicação.'"
      [reportsBoxHeight]="'440px'" [loading]="usersPerAppsLoading" [isUserPerApps]="true"
      [updateDate]="userPerAppsUpdateDate">
      <ng-select [items]="dashboardUsersPerApps" [(ngModel)]="selectedUsersPerApps" [searchable]="false"
        [clearable]="false" (change)="onChangeSelectProductInUsersPerApp($event)">
        <ng-template ng-label-tmp ng-option-tmp let-item="item" let-index="index">
          <div class="select-item">
            <img [src]="item.urlImage" />
            {{item.productName}}
          </div>
        </ng-template>
      </ng-select>

      <!-- users-per-app -->
      <div class="users-per-app" *ngIf="selectedUsersPerApps">
        <div class="users-per-app__reports">
          <p class="reports__label">Total</p>
          <p class="reports__value" [ngStyle]="{'color': selectedUsersPerApps.productColor}">
            {{selectedUsersPerApps.total}}</p>
        </div>
        <div class="users-per-app__graphic">
          <seb-progress-bar *ngFor="let profile of selectedUsersPerApps.profiles"
            [label]="profile.profileName" [percentage]="profile.percentage" [value]="profile.total"
            [backgroundColor]="selectedUsersPerApps.productColor">
          </seb-progress-bar>
        </div>
      </div>
      <!--/ users-per-app -->
    </seb-reports-box>
  </div>
  <!--/ dashboard__column -->

  <div class="dashboard__column">
    <seb-reports-box [title]="'Índice de Utilização Digital'" [isSelectVisible]="true" [selectItems]="seriesDigitalUsages"
      [selectedItem]="selectedSerieDigitalUsage" [selectBindLabel]="'segmentName'"
      (selectChange)="onChangeSelectSeriesDigitalUsage($event)" (selectProfile)="onSelectProfile($event)"
      [tooltipText]="'São contabilizados os acessos nos aplicativos através do LEX Education.'"
      [reportsBoxHeight]="'calc(100% - 30px)'" [loading]="digitalUsagesLoading"
      [selectProfiles]="profiles" [selectedProfile]="selectedProfile" [selectBindLabelProfile]="'profileName'"
      [isDigitalUsages]="true" [updateDate]="digitalUsageUpdateDate">
      <seb-digital-usage-table [products]="dashboardDigitalUsages"></seb-digital-usage-table>
    </seb-reports-box>
  </div>
  <!--/ dashboard__column -->

</div>
